import api from "./api";
import type { AgentChatRequest, AgentChatResponse } from "../types/api";

export const chatWithAgent = async (
  message: string,
  context: string | null = null,
  history: AgentChatRequest["history"] = [],
  files: string[] = [],
  pdfList: Record<string, unknown>[] | null = null
): Promise<AgentChatResponse> => {
  const requestBody: AgentChatRequest = { message, context: context ?? undefined, history, files };
  if ((context === "inventory" || context === "material-receipts") && pdfList) {
    requestBody.pdf_list = pdfList;
  }
  const response = await api.post<AgentChatResponse>("/api/v1/agent/chat", requestBody);
  return response.data;
};

export default { chatWithAgent };
